var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',_vm._b({attrs:{"direction":_vm.direction,"active":_vm.active,"simple":_vm.simple}},'el-steps',_vm.$attrs,false),_vm._l((_vm.steps),function(item,index){return _c('el-step',{key:index,attrs:{"title":item.title,"icon":item.icon,"description":item.description}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }